import React from "react";

/**
 * Building/office icon shown inside the company-name input (matches the design's
 * inline SVG: stroke=currentColor, colored via the field icon wrapper).
 */
const BuildingIcon = ({ size = 17 }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
    >
        <path d="M3 21h18M6 21V5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16M10 8h.01M14 8h.01M10 12h.01M14 12h.01M10 16h.01M14 16h.01" />
    </svg>
);

export default BuildingIcon;
